import { render, staticRenderFns } from "./tro-choi-lo-de.vue?vue&type=template&id=5a287d4a&"
import script from "./tro-choi-lo-de.vue?vue&type=script&lang=js&"
export * from "./tro-choi-lo-de.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports